import { useEffect } from 'react';

import { eventBus } from '~shared/lib';

import {
  isShareFeedbackPayload,
  SHARE_SUCCEEDED_TYPE,
} from './shareFeedbackTypes';
import { dequeueOldestShareToast } from './shareToastQueue';
import { useReopenShare } from './useReopenShare';
import { useShareToast } from './useShareToast';

type InstagramShareFeedbackListenerProps = {
  pharmacyId: string;
};

export function InstagramShareFeedbackListener({
  pharmacyId,
}: InstagramShareFeedbackListenerProps) {
  const { resolve } = useShareToast();
  const reopen = useReopenShare(pharmacyId);

  useEffect(() => {
    return eventBus.subscribe((data) => {
      if (!isShareFeedbackPayload(data)) {
        return;
      }

      const toastId = dequeueOldestShareToast(data.source);

      if (!toastId) {
        return;
      }

      if (data.type === SHARE_SUCCEEDED_TYPE) {
        resolve(toastId, 'success');

        return;
      }

      console.error('Instagram share failed', data.error);

      resolve(toastId, 'error', () =>
        reopen({
          postMessage: data.input?.caption ?? '',
          imageUrl: data.input?.imageUrls?.[0] ?? '',
          shareUrl: '',
          source: data.input?.source ?? data.source,
        })
      );
    });
  }, [resolve, reopen]);

  return null;
}
